import React, { Component, PropTypes } from "react";

import {
  NitroHeading,
  NitroButton,
  NitroButtonGroup,
  NitroPanel,
  NitroText,
  NitroIcon
} from "nitro-components";

import styled from "styled-components";

import DriverAvatar from "./DriverAvatar";

const DriverPanel = styled.section`
  margin-bottom: ${props => props.bottom}px;
`;

const DriverDetail = styled.section`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content:space-between;
  opacity:0.85;
  transition: all .2s ease-in-out;
  &:hover{
  opacity:1;
  transform: scale(1.03);
  cursor:pointer;
  }
`;

/*const DriverAvatar = styled.div`
  position: relative;
  float: left;
  margin-right: 20px;
  border-radius: 100%;
  width: 60px;
  height: 60px;
  background: ${props => props.theme.color.border};
`;
const DriverIcon = styled.i`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;*/

const DetailContainer = styled.div`
  flex: 1;
  width: 100%;
`;
const DriverTitleText = styled.div`
  padding-right: 15px;
  color: ${props => props.theme.color.base3};
`;
const InfoIcon = styled.span`
  line-height: 20px;
  float: right;
  padding: 0 12px;
`;

const DriverInformation = styled.section`
    border: 1px solid ${props => props.theme.color[props.variant]};
    text-align: center;
    padding: 12px;
    margin: 10px 0;
`;

const ButtonContainer = styled(NitroButtonGroup)`
    margin: 20px 0 0 0;
`;

const SideButtonContainer = styled.div`
    height: 30px;
    width: 30px;
    border-radius: 4px;
    align-items: center;
    display: flex;
    justify-content: center;
    background-color: ${props => props.theme.color.white};
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
    margin-right:20px;
    text-align:center;
    vertical-align:center;
`;

class DriverDetailsCard extends Component {
  onPanelClick = () => {
    if (this.props.disablePanelClick) {
      return;
    }

    const id = this.props.driverId;

    if (this.props.route) {
      this.context.router.push({
        pathname: this.props.route,
        state: { id, dashboardType: "driver" }
      });
      return;
    }

    if (typeof this.props.onPanelClick === 'function') {
      this.props.onPanelClick(id);
    }
  };

  renderAllocationButtons() {
    const {
      buttonText,
      onButtonClick,
      redirectedDriverProfile,
    } = this.props;

    if (!buttonText && !redirectedDriverProfile) {
      return null;
    }

    return (
      <ButtonContainer>
        {redirectedDriverProfile && (
          <NitroButton
            variant="primary"
            block
            label={`Allocate ${redirectedDriverProfile.DriverFirstName} ${redirectedDriverProfile.DriverSurname}`}
            size="small"
            action={() => onButtonClick(redirectedDriverProfile)}
          />
        )}
        {buttonText && (
          <NitroButton
            variant={redirectedDriverProfile ? "" : "primary"}
            block
            label={buttonText}
            size="small"
            action={onButtonClick}
          />
        )}
      </ButtonContainer>
    );
  }

  render() {
    const {
      DriverTitleMessage,
      DriverFullName,
      DriverInfoType,
      DriverInfoIcon,
      DriverInfo,
      DriverVariant,
      onButtonClick,
      buttonText,
      padding,
      sideButton,
      bookmarked,
      bottom,
      disablePanelClick,
      route,
      onPanelClick,
    } = this.props;

    const canClick = !disablePanelClick && (route || onPanelClick);

    return (
      <DriverPanel bottom={bottom}>
        <NitroPanel noMargin padding={`${padding}px`}>
          <DriverDetail onClick={this.onPanelClick}>
            {bookmarked &&
              <SideButtonContainer>
                <NitroIcon
                  name="filled-bookmark"
                  size={14}
                  variant="secondary"
                  left={3}
                />
              </SideButtonContainer>}
            <DriverAvatar
              size={60}
              profileIconVariant="white"
              profileIconSize={24}
            />

            <DetailContainer>
              <DriverTitleText>
                <NitroText size={4}> {DriverTitleMessage}</NitroText>
              </DriverTitleText>
              <NitroHeading
                noMargin
                label={DriverFullName}
                size="2"
                variant="secondary"
                inline
              />
              {DriverVariant &&
                <NitroIcon
                  name={DriverInfoIcon}
                  size={18}
                  variant={DriverVariant}
                  left={6}
                />}

            </DetailContainer>
            {canClick &&
              <InfoIcon>
                <NitroIcon name="arrow-right" size={8} variant="base3" />
              </InfoIcon>
            }
          </DriverDetail>
          {this.props.DriverInfo && (
            <DriverInformation variant={DriverVariant}>
              <NitroText size={4} bold variant={DriverVariant}>
                {DriverInfo}
              </NitroText>
            </DriverInformation>
          )}
          {this.renderAllocationButtons()}
        </NitroPanel>
      </DriverPanel>
    );
  }
}

DriverDetailsCard.defaultProps = {
  padding: 16,
  bookmarked: false,
  bottom: 48
};

DriverDetailsCard.contextTypes = {
  router: PropTypes.object
};

DriverDetailsCard.propTypes = {
  disablePanelClick: PropTypes.bool,
  route: PropTypes.string,
  driverId: PropTypes.string,
  DriverFullName: PropTypes.string,
  DriverTitleMessage: PropTypes.string,
  DriverInfoIcon: PropTypes.string,
  DriverVariant: PropTypes.string,
  DriverInfo: PropTypes.string,
  onPanelClick: PropTypes.func,
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  sideButton: PropTypes.object,
  Url: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  redirectedDriverProfile: PropTypes.object,
  bookmarked: PropTypes.bool,
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DriverDetailsCard;



// WEBPACK FOOTER //
// ./src/components/driver/DriverDetailsCard.js